// import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
// import Form from 'react-bootstrap/Form';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
// import NavDropdown from 'react-bootstrap/NavDropdown';
import Offcanvas from 'react-bootstrap/Offcanvas';

const Navigation = () => {
  return (
    <div>
        {/* <NavLink to='/inicio'>Inicio</NavLink>
        <NavLink to='/menu'>Menu</NavLink>
        <NavLink to='/reservas'>Reservas</NavLink>
        <NavLink to='/nosotros'>Nosotros</NavLink>
        <NavLink to='/contactanos'>Contactanos</NavLink> */}

              <>
                {['sm'].map((expand) => (
                  <Navbar key={expand} bg="warning" expand={expand}>
                    <Container fluid>
                      <Navbar.Brand href="/" className='h1'>La bodega cervecera</Navbar.Brand>
                      <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`} />
                      <Navbar.Offcanvas
                        id={`offcanvasNavbar-expand-${expand}`}
                        aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
                        placement="end"
                      >
                        <Offcanvas.Header className='bg-warning h1' closeButton>
                          <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
                            La bodega cervecera
                          </Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                          <Nav className="justify-content-start flex-grow-1 pe-3">
                            <Nav.Link href='/' className='text-white bg-dark border-dark rounded m-1 p-2'>Inicio</Nav.Link>
                            <Nav.Link href='/cartadisp' className='text-white bg-dark border-dark rounded m-1 p-2'>Menu</Nav.Link>
                            {/* <Nav.Link href='/reservas'>Reservas</Nav.Link>
                            <Nav.Link href='/nosotros'>Nosotros</Nav.Link>
                            <Nav.Link href='/contactanos'>Contactanos</Nav.Link> */}
                            <Nav.Link href='/reservas' className='text-white bg-dark border-dark rounded m-1 p-2'>Reservas</Nav.Link>


                            {/* <NavDropdown
                              title="Dropdown"
                              id={`offcanvasNavbarDropdown-expand-${expand}`}
                            >
                              <NavDropdown.Item href="#action3">Action</NavDropdown.Item>
                              <NavDropdown.Item href="#action4">
                                Another action
                              </NavDropdown.Item>
                              <NavDropdown.Divider />
                              <NavDropdown.Item href="#action5">
                                Something else here
                              </NavDropdown.Item>
                            </NavDropdown> */}
                          </Nav>
                          {/* <Form className="d-flex">
                            <Form.Control
                              type="search"
                              placeholder="Search"
                              className="me-2"
                              aria-label="Search"
                            />
                            <Button variant="outline-success">Search</Button>
                          </Form> */}
                        </Offcanvas.Body>
                      </Navbar.Offcanvas>
                    </Container>
                  </Navbar>
                ))}
              </>
    </div>
  )
}

export default Navigation